import { faArrowDownToBracket } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconButton, Tooltip } from '@mui/material';

type DownloadButtonProps = {
  onClick: () => void;
};

export const DownloadButton = (props: DownloadButtonProps) => {
  return (
    <Tooltip title="Download">
      <IconButton
        color="primary"
        sx={{ margin: 'auto' }}
        onClick={props.onClick}
      >
        <FontAwesomeIcon
          icon={faArrowDownToBracket}
          style={{ height: '1.5rem' }}
        />
      </IconButton>
    </Tooltip>
  );
};
